module.exports = __webpack_public_path__ + "media/images/flags/16/South-Ossetia-6589fe43a5605f65bf66336a7f692a93.png";